// extracted by mini-css-extract-plugin
export default {"inline":"axZNu0","external":"bxZNu0"};